<template>
  <section class="search-client" v-if="filterSettings">
    <template v-if="!errorMessage">
      <form @submit.prevent="searchClient">
        <div v-if="clientType !== 3">
          <div class="row">
            <div class="col-md-6" v-if="filterSettings.person.show">
              <select-field
                v-model="filter.person"
                :disabled="filterSettings.person.disabled"
                placeholder="Тип"
                :mb="5"
                id="client.filter.person"
                class="form-check-sm justify-content-center"
                :options="{true:'Физ. лицо', false:'Юр. лицо'}"
              />
            </div>
            <div class="col-md-6" v-if="filterSettings.resident.show">
              <select-field
                v-model="filter.resident"
                :disabled="filterSettings.resident.disabled"
                placeholder="Резидентство"
                :mb="5"
                id="client.filter.resident"
                class="form-check-sm justify-content-center"
                :options="{true:'Резидент', false:'Не резидент'}"
              />
            </div>
          </div>
        </div>
        <template v-if="filterStep !== 1">
          <div class="row">
            <div class="col-md-6" v-if="searchSettings.phone.show">
              <input-mask-field
                v-model="search.phone"
                id="search.phone"
                name="search_phone"
                :disabled="this.loading || searchSettings.phone.disabled"
                :required="searchSettings.phone.required"
                :has-error="hasClient"
                :mb="5"
                placeholder="Номер телефона"
                mask="+7(###) ###-####"
                type="text"
              />
            </div>
            <div class="col-md-6" v-if="searchSettings.iin.show">
              <input-mask-field
                v-if="this.filterStep === 0 || this.filterStep === 2"
                v-model="search.iin"
                id="search.iin"
                name="search_iin"
                :disabled="this.loading || searchSettings.iin.disabled"
                :required="searchSettings.iin.required"
                :has-error="hasClient"
                :mb="5"
                mask="### ### ### ###"
                :placeholder="this.filterStep === 0 ? 'ИИН' : 'БИН'"
                type="text"
                >
                </input-mask-field>
              </div>
              <div class="col-md-6">
                <input-field
                  v-model="search.nomer_vu"
                  id="search.nomer_vu"
                  name="search_nomer_vu"
                  :disabled="this.loading || searchSettings.nomer_vu.disabled"
                  :required="searchSettings.nomer_vu.required"
                  :has-error="hasClient"
                  placeholder="Номер ВУ"
                  type="text"
                />
              </div>
              <div class="col-md-6 d-flex flex-column align-items-start justify-content-center mt-5 mt-md-0" v-if="searchSettings.isSocial.show || searchSettings.isDrive.show">
                <switch-box-field
                  v-if="searchSettings.isSocial.show"
                  v-model="search.isSocial"
                  :disabled="this.loading || searchSettings.isSocial.disabled"
                  id="search.isSocial"
                  name="search_isSocial"
                  placeholder="Имеются льготы"
                  class="mb-2"
                  size="h-20px w-30px"
                />
                <switch-box-field
                  v-if="searchSettings.isDrive.show"
                  v-model="search.isDrive"
                  :disabled="this.loading || searchSettings.isDrive.disabled"
                  id="search.isDrive"
                  name="search_isDrive"
                  placeholder="Будет водителем"
                  size="h-20px w-30px"
                />
              </div>
            </div>
        </template>
        <div v-if="hasClient" class="text-danger text-center opacity-75 mt-3">
          Данный клиент уже добавлен.
        </div>
        <button
            v-if="!hasClient && checkClient"
            title="Поиск"
            v-html="this.loading ? 'Идет поиск...' : 'Поиск'"
            :disabled="this.loading || this.hasClient"
            class="btn btn-sm btn-primary w-100 mt-5"
            type="submit">
        </button>
      </form>
    </template>
  </section>
</template>

<script>
// Fields
import InputMaskField from '@/components/Fields/InputMaskField'
import SelectField   from '@/components/Fields/SelectField'
import InputField     from '@/components/Fields/InputField'
import SwitchBoxField    from '@/components/Fields/SwitchBoxField'
// Other

export default {
  name: 'CustomerBpmSearch',
  components: { InputMaskField, SelectField, SwitchBoxField, InputField },
  emits: ['create-client', 'change-filter-step'],
  props: {
    isClear: {
      type: Boolean,
      default: false
    },
    clientAddedList: {
      type: Array,
      default: () => []
    },
    afterSet: {
      type: Object,
      default: null
    },
    clientType: {
      type: Number,
      default: 0
    },
    module: {
      type: Function,
      required: true
    },
    searchData: {
      type: Object,
      default: null
    },
    processId: {
      type: String,
      default: null
    },
    mode: {
      type: [Object, Function],
      required: true
    }
  },
  data () {
    const modeCtx = { mode: this.mode, clientType: this.clientType }
    const filterSettings = this.module.Client.filterFieldsSettings(this.clientType, modeCtx)
    const filterValues = this.module.Client.filterFields(this.clientType)
    const searchValues = this.module.Client.searchFields(this.clientType, filterValues.person, filterValues.resident)
    const searchSettings = this.module.Client.searchFieldsSettings(this.clientType, filterValues.person, filterValues.resident, modeCtx)
    return {
      filter: filterValues,
      search: searchValues,
      filterSettings: filterSettings,
      searchSettings: searchSettings,
      errorMessage: '',
      checkClient:  false,
      filterStep:   0,
      loading:      false,
      hasClient:    false,
      info:         null,
    }
  },
  methods: {
    formatIin(value) {
      const digitsOnly = String(value || '').replace(/\s+/g, '')
      return digitsOnly.replace(/(.{3})/g, '$1 ').trim()
    },
    normalizeSearchData(val) {
      if (!val || typeof val !== 'object') {
        return val
      }
      return {
        ...val,
        phone: val.phone ?? '7',
        nomer_vu: val.nomer_vu ?? '',
        iin: this.formatIin(val.iin ?? ''),
      }
    },
    clearForm() {
      this.errorMessage = ''
      this.checkClient  = false
      this.filterStep   = 0
      this.loading      = false
      this.hasClient    = false
      const emptyClient = this.module.Client.empty(this.clientType)
      this.filter = {
        ...emptyClient.filter,
        resident: this.filterSettings ? this.filterSettings.resident.value : emptyClient.filter.resident,
        person: this.filterSettings ? this.filterSettings.person.value : emptyClient.filter.person,
        verify: this.filterSettings ? this.filterSettings.verify.value : emptyClient.filter.verify,
      }
      this.search = this.module.Client.searchFields(this.clientType, this.filter.person, this.filter.resident)
      this.info         = null
    },
    searchClient() {
      let search = this.cleanSearch(structuredClone(this.search))
      this.$emit('search-client', {search: search, filter: this.filter, clientType: this.clientType, processId: this.processId})
    },
    cleanSearch(search) {
      search.iin = (search.iin || '').replace(/ /g,'')
      search.nomer_vu = (search.nomer_vu || '').replace(/ /g,'')
      // Format phone number to "7XXXXXXXXXX" (if possible)
      if (search.phone) {
        let digits = search.phone.replace(/\D/g, ''); // remove non-digits
        if (digits.startsWith('7') && digits.length === 11) {
          search.phone = digits;
        } else if (digits.length === 10) {
          search.phone = '7' + digits;
        } else {
          search.phone = digits; // fallback
        }
      }
      return search
    },
    clearAfterError(message = null) {
      this.loading = false
      if (message) {
        this.$notifyError({message: message})
      }
    },
  },
  watch: {
    clientType: {
      immediate: true,
      handler () {
        const modeCtx = { mode: this.mode, clientType: this.clientType }
        this.filterSettings = this.module.Client.filterFieldsSettings(this.clientType, modeCtx)
        this.filter = this.module.Client.filterFields(this.clientType)
        this.searchSettings = this.module.Client.searchFieldsSettings(
          this.clientType,
          this.filter.person,
          this.filter.resident,
          modeCtx
        )
        this.searchSettings.nomer_vu.required = this.search.isDrive
        if (this.searchData) {
          this.search = { ...this.search, ...this.normalizeSearchData(this.searchData) }
        } else {
          this.search = this.module.Client.searchFields(this.clientType, this.filter.person, this.filter.resident)
        }
      }
    },
    search: {
      deep: true,
      immediate: true,
      handler (newValue) {
        const trimmedIin = newValue.iin ? newValue.iin.replace(/ /g, '') : '';
        const digitsPhone = newValue.phone ? newValue.phone.replace(/\D/g, '') : '';
        this.hasClient = 
          this.clientAddedList.indexOf(trimmedIin) >= 0 || 
          this.clientAddedList.indexOf(newValue.nomer_vu) >= 0 || 
          this.clientAddedList.indexOf(digitsPhone) >= 0;

        this.searchSettings.nomer_vu.required = this.search.isDrive
   
        if (Object.prototype.hasOwnProperty.call(newValue, 'phone') && (newValue.phone == null || newValue.phone === '')) {
          this.search.phone = '7'
        }
        if (Object.prototype.hasOwnProperty.call(newValue, 'iin')) {
          const formattedIin = this.formatIin(newValue.iin)
          if (formattedIin !== newValue.iin) {
            this.search.iin = formattedIin
            return
          }
        
        }
        this.checkClient = !!this.module.Validator.isSearchFormFieldsFilled(this.filter.resident, this.filter.person, this.clientType, newValue, this.searchSettings );
      }
    },
    searchData: {
      immediate: true,
      handler(val) {
        if (val) {
          this.search = this.normalizeSearchData(val)
        }
      }
    },
    filter: {
      deep: true,
      handler (newValue) {
        this.searchSettings = this.module.Client.searchFieldsSettings(
          this.clientType, this.filter.person, this.filter.resident,
          { mode: this.mode, clientType: this.clientType }
        )
        this.searchSettings.nomer_vu.required = this.search.isDrive
        if (this.searchData) {
          this.search = { ...this.search, ...this.normalizeSearchData(this.searchData) }
        } else {
          this.search     = this.module.Client.searchFields(this.clientType, this.filter.person, this.filter.resident)
        }
        this.filterStep = this.module.Client.filterStep(newValue)
        this.$emit('change-filter-step', this.filterStep)
      }
    },
    isClear: {
      immediate: true,
      handler(val) {
        if (val) this.clearForm()
      }
    },
    afterSet: {
      deep: true,
      handler (newValue) {
        if (newValue) {
          if (newValue.search) {
            this.search = this.normalizeSearchData(newValue.search)
          }
          this.filter = newValue.filter
        } else {
          const emptyClient = this.module.Client.empty(this.clientType)
          this.search = emptyClient.search
          this.filter = emptyClient.filter
        }
      }
    },
    'filter.resident': {
      immediate: true,
      handler(val) {
        this.filter.verify = val
      }
    },
    filterSettings: {
      immediate: true,
      handler(val) {
        if (val) {
          const emptyClient = this.module.Client.empty(this.clientType)
          this.filter = {
            ...emptyClient.filter,
            resident: val ? this.filterSettings.resident.value : emptyClient.filter.resident,
            person:   val ? this.filterSettings.person.value   : emptyClient.filter.person,
            verify:   val ? this.filterSettings.verify.value   : emptyClient.filter.verify
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>